import * as React from "react";
function SvgChevronDown(props, svgRef) {
  return <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path d="M3 12L9 18L15 12" style={{
      stroke: "var(--svg-color, #000)"
    }} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" transform="" /></svg>;
}
const ForwardRef = React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "src/assets/icons/chevron-down.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/chevron-down_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/chevron-down_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/chevron-down_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/chevron-down_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/chevron-down_4x.svg"
};
export { ForwardRef as ReactComponent };